import React, {memo, useMemo} from 'react';
import cl from 'classnames';
import PropTypes from 'prop-types';
import {Link} from 'react-router-dom';
import './PayStatus.less';
import {ROUTES} from '../../../configs/routes';

function PayStatus({user, language}) {
  const currentTariff = useMemo(() => (user.tariff || {}), [user]);

  const currentTariffDetails = useMemo(() => (currentTariff.details || {}), [currentTariff]);

  const tariffName = useMemo(() => {
    const tName = currentTariffDetails.name || {};
    return tName[language] || '';
  }, [currentTariffDetails, language]);

  return (
    <Link
      to={{
        pathname: ROUTES.PROFILE_SETTINGS.route,
        hash: '#plan',
      }}
      alt={tariffName}
      title={tariffName}
      className={cl('pay-status', {
        free: currentTariffDetails.default || !user.tariff,
      })}
    />
  );
}

PayStatus.propTypes = {
  user: PropTypes.shape({}),
  language: PropTypes.string,
};

PayStatus.defaultProps = {
  user: {},
  language: 'ru',
};

export default memo(PayStatus);
